<template>
  <div>
    <vs-popup title="پیش نمایش عکس" :active.sync="imagePreviewVisible">
      <div class="image-preview-container">
        <img :src="image" alt="preview" />
      </div>
    </vs-popup>
  </div>
</template>

<script>
export default {
  name: "ImagePreview",
  data() {
    return {
      imagePreviewVisible: false,
    };
  },
  methods: {
    togglePreviewVisibility() {
      this.imagePreviewVisible = !this.imagePreviewVisible;
    },
  },
  props: {
    image: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.image-preview-container {
  display: flex;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    max-height: 500px;
    border-radius: 5px;
    object-fit: contain;
    margin: 0 auto;
  }
}
</style>